function deepCopyArray (arg) {
  if (!isArray(arg)) {
    throw TypeError('Expected Array');
  }
  return deepCopyCollection(arg);
}

function deepCopyCollection (arg) {
  return JSON.parse(JSON.stringify(arg));
}

function deepCopyObject (arg) {
  if (!isObject(arg)) {
    throw TypeError('Expected Object');
  }
  return deepCopyCollection(arg);
}

function isArray (arg) {
  return arg !== undefined && arg !== null && Array.isArray(arg);
}

function isFile (arg) {
  return arg instanceof File;
}

function isFormData (arg) {
  return arg instanceof FormData;
}

function isNumber (arg) {
  return typeof arg === 'number' && !isNaN(arg);
}

function isObject (arg) {
  return Object.prototype.toString.call(arg) === '[object Object]';
}

function isString (arg) {
  return typeof arg === 'string' || arg instanceof String;
}

export {
  deepCopyArray,
  deepCopyCollection,
  deepCopyObject,
  isNumber,
  isFile,
  isFormData,
  isObject,
  isString,
};
